






















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { dictServe, institutionServer, performanceServer, userServe } from '@/api/installServer';
import SafetyAndEnvironmentDialog from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/safetyAndEnvironmentDialog.vue';
import ChoosePersonDialog from '@/views/inventoryManagement/unit/choosePersonDialog.vue';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { ChoosePersonDialog, SafetyAndEnvironmentDialog },
})
export default class AssessmentPageComponent extends Vue {
  @Prop(Object) editData!: any; // 传递给编辑页面-数据对象
  @Prop(String) NewType!: any; // 传递给编辑页面-类型

  // 表单数据
  formData: any = {};

  formRules: any = {};
  deptObj: any = {};
  postObj: any = [];
  personObj: any = {};
  taskOptions: any = [];

  isLoading: any = false; // 点击确定之后

  // 执行部门
  spaceDeptByAuthOptions: any = [];

  // 职务
  spacePostByAuthOptions: any = [];

  // 人员
  spaceStaffByAuthOptions: any = [];

  subSpaceByAuthOptions: any = [
    {
      value: '固定',
      label: '固定',
    },
    {
      value: '动态',
      label: '动态',
    },
  ];

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.getSubSpaceByAuth();
    const a: any = new Date().getFullYear();
    this.formData.year = a.toString();
    this.isLoading = false;
    this.deptObj = {};
    this.postObj = [];
    this.personObj = {};
    this.getDetailByIdData();
    setTimeout(() => {
      this.getDataById();
    }, 500);
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.spaceDeptByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffByAuth(id: any) {
    // 发起接口请求，获取分页数据
    userServe
      .getPageDataAll({ deptId: id })
      .then((res: any) => {
        this.spaceStaffByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getDetailByIdData() {
    // 发起接口请求，获取分页数据
    dictServe
      .getDetailsMapByName('frequency')
      .then((res: any) => {
        for (const key in res.data) {
          this.taskOptions.push({
            value: key,
            label: res.data[key],
          }); //属性
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getDataById() {
    // 发起接口请求，获取分页数据
    performanceServer
      .getDutyRuleListDetail(this.editData.id)
      .then((res: any) => {
        this.formData = res.data;
        if (res.data.executeStaffId) {
          this.getSpaceStaffByAuth(res.data.executeDepartmentId);
          this.formData.name = res.data.executeStaffName;
          const selectedDeptName = this.spaceDeptByAuthOptions.find((item: any) => {
            return item.id === res.data.executeDepartmentId;
          });
          this.deptObj = selectedDeptName;
          setTimeout(() => {
            const selectedPersonName = this.spaceStaffByAuthOptions.find((item: any) => {
              return item.id === res.data.executeStaffId;
            });
            this.personObj = selectedPersonName;
            if (res.data.executePostIds) {
              const newPostList: any = res.data.executePostIds.split(',');
              const needLsit: any = [];
              newPostList.forEach((inner: any) => {
                needLsit.push({ postId: inner });
              });
              this.postObj = needLsit;
            }
          }, 300);
        }
        if (res.data.executeDepartmentId && !res.data.executeStaffId) {
          this.formData.name = res.data.executeDepartmentName;
          const selectedName = this.spaceDeptByAuthOptions.find((item: any) => {
            return item.id === res.data.executeDepartmentId;
          });
          this.deptObj = selectedName;
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  changeProject() {
    // if (this.formData.assessType) {
    const safetyDialog = 'safetyDialog';
    const safetyDialogComponent = this.$refs[safetyDialog];
    (safetyDialogComponent as any).showDialog(this.formData.assessType); // 传给弹窗的数据 检查标准项(即 检查内容)
    // } else {
    //     this.$message.warning('请先选择考核类型！');
    // }
  }

  choosePersonLiable() {
    const safetyDialog = 'choosePersonDialog';
    const safetyDialogComponent = this.$refs[safetyDialog];
    (safetyDialogComponent as any).showDialog(this.deptObj, this.postObj, this.personObj); // 传给弹窗的数据 检查标准项(即 检查内容)
  }

  /**
   * @desc 检查内容弹窗中所选的数据
   * */
  getData(data: any) {
    console.log(data);
    if (data) {
      this.formData.assessContent = data.assessContent;
      this.formData.assessStand = data.assessStand;
      this.formData.assessContentId = data.id;
      this.formData.assessProjectName = data.assessProject;
    } else {
      this.formData.assessContent = '';
      this.formData.assessStand = '';
      this.formData.assessContentId = '';
      this.formData.assessProjectName = '';
    }
    this.$forceUpdate();
  }

  /**
   * @desc 检查内容弹窗中所选的数据
   * */
  getPersonData(deptData: any, postData: any, personData: any) {
    this.deptObj = deptData;
    this.postObj = postData;
    this.personObj = personData;
    if (deptData.id && !personData.id) {
      this.formData.executeDepartmentId = deptData.id;
      this.formData.executeDepartmentName = deptData.name;
      this.formData.executeStaffId = '';
      this.formData.executeStaffName = '';
      this.formData.name = deptData.name;
    }
    if (deptData.id && personData.id) {
      this.formData.executeDepartmentId = deptData.id;
      this.formData.executeDepartmentName = deptData.name;
      this.formData.executeStaffId = personData.id;
      this.formData.executeStaffName = personData.name;
      this.formData.name = personData.name;
    }
    if (postData && postData.length > 0) {
      const idList: any = [];
      const nameList: any = [];
      postData.forEach((r: any) => {
        idList.push(r.postId);
        nameList.push(r.postName);
      });
      this.formData.executePostIds = idList.toString();
      this.formData.executePostNames = nameList.toString();
    }
    if (postData && postData.length === 0) {
      this.formData.executePostIds = '';
      this.formData.executePostNames = '';
    }
    this.$forceUpdate();
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.isLoading = false;
    this.formData = {};
    this.$emit('refreshData');
  }

  /**
   * @desc 点击取消按钮
   */
  saveHazardType() {
    this.isLoading = true;
    this.formData.frequency = parseInt(this.formData.frequency);
    this.formData.referWeights = parseInt(this.formData.referWeights);
    delete this.formData.name;
    performanceServer
      .editDutyRuleList(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('编辑成功！');
          this.isLoading = false;
          this.close();
        } else {
          this.isLoading = false;
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.$message.warning('编辑数据失败！');
      });
  }
}
